import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "../../../../common";
import { useStores } from "../../../../../stores";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface SignInProps {}

export const SignInButton = observer(({}: SignInProps) => {
	const { t } = useTranslation();

	const { authStore } = useStores();
	const navigate = useNavigate();

	const handleOnShow = () => {
		navigate("/sign/login");
	};

	if (authStore.isAuth) return null;

	return (
		<>
			<Button onClick={handleOnShow}>{t("buttons.sign_in")}</Button>
		</>
	);
});
